import { SHStack, SHTypography } from "@components/design-systems";
import React from "react";
import { useTheme } from "@mui/material";
import { TextBoxIcon } from "src/components/svgs/text-box";

export const MSTableClickToViewIcon = () => {
  const { palette } = useTheme();

  return (
    <SHStack
      textAlign={"left"}
      position={"relative"}
      direction={"row"}
      gap={0.5}
    >
      <SHTypography
        variant={"body2"}
        fontSize={13}
        lineHeight={1}
        sx={{
          textDecoration: "underline",
          color: palette.primary.dark,
        }}
      >
        Details
      </SHTypography>

      <SHStack position={"absolute"} right={"-20px"} top={"-5px"}>
        <TextBoxIcon fill={palette.primary.dark} width={"15px"} />
      </SHStack>
    </SHStack>
  );
};
